import { useState, useRef, useCallback } from 'react'

const useQueue = () => {
  const [queue, setQueue] = useState([])
  const [isProcessing, setIsProcessing] = useState(false)
  const [errors, setErrors] = useState([])
  const resultsRef = useRef([])
  const errorsRef = useRef([])

  const addTask = useCallback((task) => {
    setQueue((prevQueue) => [...prevQueue, task]) // Add task to queue
  }, [])

  const processQueue = useCallback(async () => {
    if (isProcessing || queue.length === 0) return // Avoid duplicate processing
    setIsProcessing(true)

    while (queue.length > 0) {
      const task = queue.shift() // Get the first task
      try {
        const result = await task() // Execute the task
        resultsRef.current.push(result)
      } catch (error) {
        errorsRef.current.push(error)
        setErrors([...errorsRef.current]) // Update errors
      }
    }

    setQueue([]) // Clear queue after processing
    setIsProcessing(false)
  }, [isProcessing, queue])

  return { addTask, processQueue, isProcessing, errors }
}

export default useQueue
